import { ICellRendererParams } from 'ag-grid-community';

import {
  areValidProgressBarProps,
  ProgressBar,
  type ProgressBarProps,
} from '../../progressBar/ProgressBar';
import { EMPTY_VALUE } from '../valueFormatters';

import { DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED } from './constants';

import styles from './progressBarCellRenderer.module.scss';

export type IProgressBarCellRendererParams = ICellRendererParams & {
  progressBar: ProgressBarProps;
};

export const ProgressBarCellRenderer = ({
  formatValue,
  progressBar,
  value,
}: IProgressBarCellRendererParams) => {
  if (value === undefined) {
    return;
  }

  if (!areValidProgressBarProps(progressBar)) {
    throw new Error(
      `ProgressBarRenderer called with invalid value: ${JSON.stringify(progressBar)}`
    );
  }

  if (progressBar.segments.length === 0) {
    return formatValue?.(progressBar.segments) ?? EMPTY_VALUE;
  }

  return (
    <div
      {...DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED}
      className={styles['root']}
      data-testid="progress-bar-cell"
    >
      <ProgressBar {...progressBar} />
    </div>
  );
};
